export default "__VITE_ASSET__BByJXXHJ__"